export const APPLICATION_STATUS_APPROVED = 'approved';
export const APPLICATION_STATUS_REJECTED = 'rejected';
export const APPLICATION_STATUS_RETURNED = 'returned';
export const APPLICATION_STATUS_IN_PROGRESS = 'in-progress';
export const APPLICATION_STATUS_SUBMITTED = 'submitted';
export const APPLICATION_STATUS_FAKE = 'fake';
